// @file Helper for Whiteboard (tools, colors, etc)
import device from '@@/bits/device'
import { __ } from '@@/bits/intl'
import { ActionType } from '@@/bits/whiteboard'
import { useTldrawEditor } from '@@/vuecomposables/useTldrawEditor'
import { useWhiteboardShapeHandlers } from '@@/vuecomposables/whiteboard_shape_handlers'
import type { TLShape } from 'tldraw'

const MOD_KEY = device.mac ? '⌘' : 'Ctrl+'
const copyRow = {
  icon: 'copy_outline',
  text: __('Copy'),
  eventPayload: ActionType.Copy,
  rightLabel: `${MOD_KEY}C`,
}
const cutRow = {
  icon: 'scissors',
  text: __('Cut'),
  eventPayload: ActionType.Cut,
  rightLabel: `${MOD_KEY}X`,
}
const pasteRow = {
  icon: 'clipboard_outline',
  text: __('Paste'),
  eventPayload: ActionType.Paste,
  rightLabel: `${MOD_KEY}V`,
}
const duplicateRow = {
  icon: 'duplicate_outline',
  text: __('Duplicate'),
  eventPayload: ActionType.Duplicate,
  rightLabel: `${MOD_KEY}D`,
}
const selectAllRow = {
  icon: 'select_all',
  text: __('Select all'),
  eventPayload: ActionType.SelectAll,
  rightLabel: '⇧A',
}
const freezeRow = {
  icon: 'freeze',
  text: __('Freeze'),
  eventPayload: ActionType.ToggleFreeze,
  rightLabel: '⇧F',
}
const unfreezeRow = {
  icon: 'freeze',
  text: __('Unfreeze'),
  eventPayload: ActionType.ToggleFreeze,
}
const sendToFrontRow = {
  icon: 'send_to_front_outline',
  text: __('Send to front'),
  eventPayload: ActionType.SendToFront,
  rightLabel: ']',
}
const sendToBackRow = {
  icon: 'send_to_back_outline',
  text: __('Send to back'),
  eventPayload: ActionType.SendToBack,
  rightLabel: '[',
}
const groupRow = {
  icon: 'group_shapes',
  text: __('Group'),
  eventPayload: ActionType.Group,
  rightLabel: `${MOD_KEY}G`,
}
const ungroupRow = {
  icon: 'ungroup_shapes',
  text: __('Ungroup'),
  eventPayload: ActionType.Ungroup,
  rightLabel: `${MOD_KEY}⇧G`,
}
const deleteRow = {
  icon: 'delete',
  text: __('Delete'),
  eventPayload: ActionType.Delete,
  rightLabel: '⌫',
}
const editPollRow = {
  icon: 'pencil_outline',
  text: __('Edit poll'),
  eventPayload: ActionType.EditPoll,
}
const openPollRow = {
  icon: 'poll_open',
  text: __('Open poll'),
  eventPayload: ActionType.OpenPoll,
}
const closePollRow = {
  icon: 'poll_close',
  text: __('Close poll'),
  eventPayload: ActionType.ClosePoll,
}
const exportPollRow = {
  icon: 'download_outline',
  text: __('Export poll results as CSV'),
  eventPayload: ActionType.ExportPoll,
}

function checkCanEdit(shape: TLShape): boolean {
  const editor = useTldrawEditor().editor
  if (editor == null) return false
  const shapeHandlers = useWhiteboardShapeHandlers(editor)
  return shapeHandlers.checkCanEdit(shape)
}

export {
  checkCanEdit,
  closePollRow,
  copyRow,
  cutRow,
  deleteRow,
  duplicateRow,
  editPollRow,
  exportPollRow,
  freezeRow,
  groupRow,
  MOD_KEY,
  openPollRow,
  pasteRow,
  selectAllRow,
  sendToBackRow,
  sendToFrontRow,
  unfreezeRow,
  ungroupRow,
}
